export default {
    text_1: "Vlastné farby ponuky",
    text_2: "Vlastné farby ponuky",
    text_3: "Nastavenie vlastnej farby",
    text_4: "Personalizuj svoje ponuky a použi vlastné farby, aby ladili s tvojim logom či firemnými farbami. Farby môžeš kedykoľvek meniť.",
    text_5: "Uložiť",
    text_6: "Vyber si svoju farebnú kombináciu",
    text_7: "alebo použi vlastnú farbu",
    text_8: "Tvoja cenová ponuka bude vyzerať nasledovne:",
    text_9: "Farba ponuky bola uložená."
}